<template>
  <div class="composer">
    <textarea placeholder="Type a message..."></textarea>
    <div class="footer">
      <button class="send-btn">Send</button>
    </div>
  </div>
</template>

<style scoped>
.composer {
  border-top: 1px solid #eef2f7;
  padding: 0;
}

textarea {
  width: 100%;
  min-height: 110px;
  resize: none;
  border: none;
  outline: none;
  padding: 18px 20px 10px;
  font-size: 15px;
  font-family: inherit;
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 18px 18px;
}

.send-btn {
  min-width: 106px;
  height: 44px;
  border: none;
  border-radius: 14px;
  background: #2f80ed;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
</style>